import posthog from "posthog-js";

if (process.env.NODE_ENV === "production") {
  // biome-ignore lint/style/noNonNullAssertion: Fix me
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    defaults: "2025-05-24",
  });
}
